import {
  EVENT_NAME,
  EventProps,
  trackAnalyticsEvent,
} from '@leagueplatform/analytics';
import { GDSStyleObject, Icon, TextAction } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';

export const BackButtonArrow = ({
  css,
  analyticsEventProps,
}: {
  css?: GDSStyleObject;
  analyticsEventProps?: EventProps;
}) => {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  const handleClick = () => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      detail: 'back arrow button',
      ...analyticsEventProps,
    });
    navigate(-1);
  };

  return (
    <TextAction
      onClick={handleClick}
      as="button"
      css={{
        color: '$onSurfaceIconPrimary',
        ...css,
      }}
    >
      <Icon
        icon="interfaceChevronLeft"
        label={formatMessage({ id: 'STR_GO_BACK' })}
      />
    </TextAction>
  );
};
